import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AboutHotel from '../../containers/AboutHotel';
import ExtraItems from '../../containers/ExtraItemsContainer';
import Facts from '../../containers/Facts';
import Paper from '../Paper';
import PaperSeparator from '../Paper/PaperSeparator';
import EmptyAboutHotel from './EmptyAboutHotel';

const padding = 20;

const PaperWithMargin = styled(Paper)`
  margin-bottom: 10px;
`;

/**
 * DISCLAIMER
 *
 * Придумано слишком много вариаций размещения информации,
 * из-за этого неизвестно как себя поведет система при пересечении всех возможных состояний.
 * Тут покрыта хотя бы известная часть.
 */
const HotelInfo = ({
  hasRating,
  isLastReview,
  hasFacts,
  hasExtraItems,
  hasAboutHotel,
  isHotelOnly,
}) => {
  const hasSomething = hasFacts || hasRating || isLastReview;

  if (!hasExtraItems && !hasSomething && !hasAboutHotel) {
    return <EmptyAboutHotel />;
  }

  if (hasExtraItems && !hasSomething && hasAboutHotel) {
    return (
      <Paper padding={padding}>
        <StyledContainer>
          <StyledSingleContainerColumn>
            <ExtraItems />
          </StyledSingleContainerColumn>
          <StyledVerticalSeparator />
          <StyledSingleContainerColumn>
            <AboutHotel />
          </StyledSingleContainerColumn>
        </StyledContainer>
      </Paper>
    );
  }

  return (
    <StyledContainer>
      {(hasFacts || hasExtraItems) && (
        <StyledLeftColumn>
          <Paper padding={padding}>
            {hasFacts && <Facts />}
            {!isHotelOnly && hasExtraItems && (
              <>
                {hasFacts && <PaperSeparator margin={padding} />}
                <ExtraItems />
              </>
            )}
          </Paper>
        </StyledLeftColumn>
      )}
      <StyledRightColumn>
        {hasSomething || hasAboutHotel ? (
          <>
            <PaperWithMargin padding={padding}>
              <AboutHotel />
            </PaperWithMargin>
          </>
        ) : (
          <EmptyAboutHotel />
        )}
      </StyledRightColumn>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
`;

const StyledSingleContainerColumn = styled.div`
  flex-basis: 50%;
`;

const StyledLeftColumn = styled.div`
  flex-basis: 530px;
  flex-grow: 1;
  margin-right: 10px;
`;

const StyledRightColumn = styled.div`
  flex-basis: 400px;
  flex-grow: 1;
`;

const StyledVerticalSeparator = styled.span`
  margin: -${padding}px 20px;
  display: block;
  width: 1px;
  background-color: #d8d8d8; // TODO: цвет должен быть из темы
  flex-shrink: 0;
`;

HotelInfo.defaultProps = {};

HotelInfo.propTypes = {
  isLastReview: PropTypes.bool.isRequired,
  hasRating: PropTypes.bool.isRequired,
  hasFacts: PropTypes.bool.isRequired,
  hasExtraItems: PropTypes.bool.isRequired,
  hasAboutHotel: PropTypes.bool.isRequired,
};

export default HotelInfo;
